import type { Rarity } from '../game/types'
import { RARITY_INFO } from '../game/families'

export default function RarityBadge({ rarity }: { rarity: Rarity }) {
  const info = RARITY_INFO[rarity]
  return (
    <span
      className="rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider"
      style={{ color: info.color, backgroundColor: info.color + '22', border: `1px solid ${info.color}55` }}
    >
      {info.label}
    </span>
  )
}
